var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-player',{ref:"videoPlayer",staticClass:"player-fit vjs-big-play-centered",attrs:{"id":"thePlayer","options":_vm.playerOptions,"disablepictureinpicture":""},on:{"play":function($event){return _vm.onPlayerPlay($event)},"ready":function($event){return _vm.onPlayerReady($event)},"ended":_vm.playbackFinished}})
}
var staticRenderFns = []

export { render, staticRenderFns }